var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 27.5,
    fill: "url(#pattern51)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern51",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4107_9059",
    transform: "scale(0.0333333 0.030303)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4107_9059",
    width: 30,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAhCAYAAADOHBvaAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHqADAAQAAAABAAAAIQAAAADpMBhSAAABXklEQVRIDe1VwXHCMBAkJA9+kA745kcplEAJdIBLIB2kgyQdpASnA6eC0AHsjkbMIulsyXaYYcLOHDrf3t75JGxPJnlYIe0d9gs7GkaOOcwdBWtUsZpZcWoGYQF125RWY2qo7Q2dtkGVZUslcjXM3wy1JqYm44iV8G/wG7kOXXJfElSthJ3b1TgSdAQOHfwFXeGqzzn6Le2z7h/QlMJr4+cRHZ9hL7DZFbu/cmKFTh9ymlfiJ2uO/efKvqH/1/gpe29cIt9Gc9gnTJ9ZK+5UGb/6TIbpGwQ8z0YeGzipuOc9x/WMkjNenlWXnz4rLumxW9I4Vg+I3BsP2Lwy6X2ry/ZrQPZNbHUjA9biW3FJid2Sd/UH5AfYAkbfw4p7PrmGH3t9n4ZcskBGMFnzJs44Y7gohceSRDjxt2TtxO/rbkWotSXs3AoLz+QvjLVbUYMduzFrZqFC1hg3wBqsFeEE3nOsn6ViyegAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteItem);
export default __webpack_public_path__ + "static/media/delete-item.291abbe578e9d83da68c9d37b8c63036.svg";
export { ForwardRef as ReactComponent };